import { useWorkspaceCtx } from '@anyx/common-workspace';

import { createPath } from '../../../utils';
import { BaseRouteProps } from '../../types/route-type';

/**
 *
 * @param workspaceStoreId set the workspace store ID to the url, use current workspace store ID by default.
 * @returns string
 */
export const UserRoutePath = ({
  workspaceStoreId = useWorkspaceCtx.getState().workspace?.storeId,
}: BaseRouteProps = {}) => {
  const root = createPath(workspaceStoreId ? '/:workspaceStoreId/user' : '/user', {
    workspaceStoreId,
  });

  return {
    root: () => root,
    self: () => createPath(`${root.path}/self`),
    notifications: () => createPath(`${root.path}/notifications`),
    list: () => createPath(`${root.path}/list`),
    add: () => createPath(`${root.path}/add`),
    edit: ({ userId = '' }) => createPath(`${root.path}/:userId`, { userId }, ['userId']),
  };
};
